import { get, getDatabase, ref, set } from 'firebase/database';
import { recordActivity } from './activityApi';
import { requireAdmin } from './adminGuard';
import { formatDateForStorage } from '../Helpers/DateUtils';
import {
    PARKING_QUEUE_RULES_MAX_LENGTH,
    PARKING_QUEUE_RULES_PATH,
    ParkingQueueRules,
    parseParkingQueueRules,
} from '../types/parkingQueueRules';

/** Reads `global/parkingQueueRules`; null when never written. */
export async function fetchParkingQueueRules(): Promise<ParkingQueueRules | null> {
    const snapshot = await get(ref(getDatabase(), PARKING_QUEUE_RULES_PATH));
    return parseParkingQueueRules(snapshot.val());
}

/** Overwrites the rules text (admin), stamping who and when. Empty text clears it. */
export async function saveParkingQueueRules(text: string): Promise<ParkingQueueRules> {
    const db = getDatabase();
    const uid = await requireAdmin(db, 'ändra reglerna för kön');
    const trimmed = text.trim();
    if (trimmed.length > PARKING_QUEUE_RULES_MAX_LENGTH) {
        throw new Error(`Reglerna får vara högst ${PARKING_QUEUE_RULES_MAX_LENGTH} tecken.`);
    }
    const value: ParkingQueueRules = { text: trimmed, updatedBy: uid, updatedWhen: formatDateForStorage(new Date()) };
    try {
        await set(ref(db, PARKING_QUEUE_RULES_PATH), value);
        recordActivity('settings.updated');
    } catch (err) {
        console.error('Failed to save parking queue rules', err);
        throw new Error('Kunde inte spara reglerna. Försök igen.');
    }
    return value;
}
